import React from 'react'
import Dashboard from '../../Screens/WarehouseManager/Dashboard'
import StockLevels from '../../Screens/WarehouseManager/StockLevels'
import ViewStock from '../../Screens/WarehouseManager/ViewStock'
import LowStockItems from '../../Screens/WarehouseManager/LowStockItems'
import StockIntake from '../../Screens/WarehouseManager/StockIntake'
import StockOut from '../../Screens/WarehouseManager/StockOut'
import StockAdjustments from '../../Screens/WarehouseManager/StockAdjustments'
import RequestStock from '../../Screens/WarehouseManager/RequestStock'
import NewTransfer from '../../Screens/WarehouseManager/NewTransfer'
import PendingTransfers from '../../Screens/WarehouseManager/PendingTransfers'
import OutgoingTransfers from '../../Screens/WarehouseManager/OutgoingTransfers'
import IncomingTransfers from '../../Screens/WarehouseManager/IncomingTransfers'
import TransferHistory from '../../Screens/WarehouseManager/TransferHistory'
import BranchRequests from '../../Screens/WarehouseManager/BranchRequests'
import BranchRequestsDetail from '../../Screens/WarehouseManager/BranchRequestsDetail'
import RequestsHistory from '../../Screens/WarehouseManager/RequestsHistory'
import PurchaseOrderReceiving from '../../Screens/WarehouseManager/PurchaseOrderReceiving'
import SupplierReturns from '../../Screens/WarehouseManager/SupplierReturns'
import GoodsReceivedNotes from '../../Screens/WarehouseManager/GoodsReceivedNotes'
import ProductList from '../../Screens/WarehouseManager/ProductList'
import StockReport from '../../Screens/WarehouseManager/StockReport'
import StockMovementReport from '../../Screens/WarehouseManager/StockMovementReport'
import AdjustmentReport from '../../Screens/WarehouseManager/AdjustmentReport'
import TransferReport from '../../Screens/WarehouseManager/TransferReport'
import SupplierReceivingReport from '../../Screens/WarehouseManager/SupplierReceivingReport'
import SlowFastMovingStock from '../../Screens/WarehouseManager/SlowFastMovingStock'
import Reports from '../../Screens/WarehouseManager/Reports'
import Profile from '../../Screens/WarehouseManager/Profile'

const Main = ({ activeScreen, isFirstLogin, screenParams }) => {
  const renderScreen = () => {
    // If first login, only allow profile screen
    if (isFirstLogin && activeScreen !== 'profile') {
      return <Profile />
    }

    switch (activeScreen) {
      case 'dashboard':
        return <Dashboard />
      case 'stock-levels':
        return <StockLevels />
      case 'view-stock':
        return <ViewStock />
      case 'low-stock-items':
        return <LowStockItems />
      case 'stock-intake':
        return <StockIntake />
      case 'stock-out':
        return <StockOut />
      case 'stock-adjustments':
        return <StockAdjustments />
      case 'request-stock':
        return <RequestStock />
      case 'new-transfer':
        return <NewTransfer />
      case 'pending-transfers':
        return <PendingTransfers />
      case 'outgoing-transfers':
        return <OutgoingTransfers />
      case 'incoming-transfers':
        return <IncomingTransfers />
      case 'transfer-history':
        return <TransferHistory />
      case 'branch-requests':
        return <BranchRequests />
      case 'branch-requests-detail':
        return <BranchRequestsDetail movement={screenParams?.movement} />
      case 'requests-history':
        return <RequestsHistory />
      case 'purchase-order-receiving':
        return <PurchaseOrderReceiving />
      case 'supplier-returns':
        return <SupplierReturns />
      case 'goods-received-notes':
        return <GoodsReceivedNotes />
      case 'product-list':
        return <ProductList />
      case 'stock-report':
        return <StockReport />
      case 'stock-movement-report':
        return <StockMovementReport />
      case 'adjustment-report':
        return <AdjustmentReport />
      case 'transfer-report':
        return <TransferReport />
      case 'supplier-receiving-report':
        return <SupplierReceivingReport />
      case 'slow-fast-moving-stock':
        return <SlowFastMovingStock />
      case 'reports':
        return <Reports />
      case 'profile':
        return <Profile />
      default:
        return <Dashboard />
    }
  }

  return (
    <main id="main" className="main">
      {renderScreen()}
    </main>
  )
}

export default Main